/**
 * A checkbox per group, with each group's scope summary: which groups a user
 * joins — in the invite dialog and in a user's groups dialog.
 */
import type { GroupWire } from '@acp/api-contract/tenancy.js';

export type GroupChecklistProps = {
  readonly groups: readonly GroupWire[];
  readonly selected: readonly string[];
  readonly onChange: (selected: string[]) => void;
};

export function GroupChecklist({ groups, selected, onChange }: GroupChecklistProps) {
  if (groups.length === 0) return <p className="text-sm text-muted-foreground">No groups yet.</p>;
  return (
    <fieldset className="grid gap-2" data-testid="group-checklist">
      <legend className="mb-1 text-sm font-medium">Groups</legend>
      {groups.map((g) => (
        <label key={g.groupId} className="flex items-start gap-2 text-sm">
          <input
            type="checkbox"
            className="mt-1"
            checked={selected.includes(g.groupId)}
            onChange={(e) => onChange(e.target.checked ? [...selected, g.groupId] : selected.filter((id) => id !== g.groupId))}
          />
          <span>
            <span className="font-medium">{g.name}</span>
            <span className="block text-xs text-muted-foreground">{g.scope.kind === 'tenant' ? 'whole tenant' : 'scoped'} · {g.permissions.length} permission{g.permissions.length === 1 ? '' : 's'}</span>
          </span>
        </label>
      ))}
    </fieldset>
  );
}
